const ProductLocationList = [
  {
    name: 'Living Room',
    label: 'Living Room',
    value: 'Living room with a sofa, coffee table, and stylish wall in a cozy interior',
  },
  {
    name: 'Kitchen',
    label: 'Kitchen',
    value: 'Kitchen with a dining area, bar counter, and functional shelving',
  },
  {
    name: 'Dining Room',
    label: 'Dining Room',
    value: 'Dining room in a country house featuring a massive wooden table and natural lighting',
  },
  {
    name: 'Bedroom',
    label: 'Bedroom',
    value: 'Bedroom with a large bed, bedside tables, and soft lighting',
  },
  {
    name: 'Children\'s Room',
    label: 'Children\'s Room',
    value: 'Children\'s room with a bright crib, toy cabinet, and a comfortable study area',
  },
  {
    name: 'Balcony (Loggia)',
    label: 'Balcony (Loggia)',
    value: 'Balcony or loggia with cozy furniture, shelves, and lush plants',
  },
  {
    name: 'Bathroom',
    label: 'Bathroom',
    value: 'Bathroom with modern accessories and stylish fixtures',
  },
  {
    name: 'Walk-in Closet',
    label: 'Walk-in Closet',
    value: 'Walk-in closet with open storage systems, mirrored surfaces, and neat organization',
  },
  {
    name: 'Entrance Hall',
    label: 'Entrance Hall',
    value: 'Well-lit entrance hall with coat racks, a pouf, and a large mirror',
  },
  {
    name: 'Garden',
    label: 'Garden',
    value: 'Garden with a green lawn, outdoor furniture, and decorative elements',
  },
  {
    name: 'Office',
    label: 'Office',
    value: 'Office space with workstations, desks, and modern chairs',
  },
  {
    name: 'Playground',
    label: 'Playground',
    value: 'Playground with slides, carousels, and vibrant play elements',
  },
  {
    name: 'Modern City',
    label: 'Modern City',
    value: 'Urban street against a backdrop of skyscrapers with a dynamic city atmosphere',
  },
  {
    name: 'Ski Resort',
    label: 'Ski Resort',
    value: 'Ski resort set against snowy mountains, cozy chalets, and ski slopes',
  },
  {
    name: 'Beach',
    label: 'Beach',
    value: 'Beach with golden sand, a blue sea, and colorful umbrellas for relaxation',
  },
  {
    name: 'Forest',
    label: 'Forest',
    value: 'Forest with dense greenery, soft light, and a serene atmosphere',
  },
  {
    name: 'Stadium',
    label: 'Stadium',
    value: 'Stadium with a spacious field, stands, and modern sports facilities',
  },
  {
    name: 'Gym',
    label: 'Gym',
    value: 'Gym with modern workout equipment, mirrors, and an energetic vibe',
  },
  {
    name: 'Hunting or Fishing Camp',
    label: 'Hunting or Fishing Camp',
    value: 'Hunting or fishing camp in nature with rustic cabins and open spaces',
  },
  {
    name: 'Park',
    label: 'Park',
    value: 'Park with green avenues, benches, and inviting rest areas',
  },
  {
    name: 'Clothing Boutique',
    label: 'Clothing Boutique',
    value: 'Clothing boutique with a stylish storefront, neatly arranged products, and a trendy interior',
  },
  {
    name: 'Jewelry Boutique',
    label: 'Jewelry Boutique',
    value: 'Jewelry boutique featuring exquisite pieces, elegant displays, and a luxurious atmosphere',
  },
  {
    name: 'Beauty Salon',
    label: 'Beauty Salon',
    value: 'Beauty salon with modern design, mirrors, and cozy treatment zones',
  },
  {
    name: 'Store',
    label: 'Store',
    value: 'Store with organized shelves, chic display windows, and an appealing product layout',
  },
  {
    name: 'Photo Studio',
    label: 'Photo Studio',
    value: 'Photo studio with professional lighting, versatile backdrops, and a stylish interior',
  },
  {
    name: 'Cafe',
    label: 'Cafe',
    value: 'Cafe with a cozy vibe, trendy furniture, and modern decor',
  },
  {
    name: 'SPA',
    label: 'SPA',
    value: 'SPA with a relaxing ambiance, soft lighting, and contemporary comforts',
  },
];

export default ProductLocationList;
